module.exports = __webpack_public_path__ + "img/img_1.b13b45a5.png";